// extracted by mini-css-extract-plugin
module.exports = {"navbar":"_1m8_H","leftSpace":"dz6ql"};